import { UploadedGuestData, UploadedStructureData } from '@features/add-participants-modal/with-excel';
import { useCustomScrollbar } from '@shared/hooks/useCustomScrollbar';
import { scrollbarStyles } from '@shared/ui/dropdown/scrollbar/styles';
import { concatArray } from '@shared/lib/concatArray';
import * as stylex from '@stylexjs/stylex';
import { styles } from './styles';

interface ErrorsUploadedUsersProps {
  uploadedData: UploadedStructureData | UploadedGuestData;
}

export const ErrorsUploadedUsers = ({ uploadedData }: ErrorsUploadedUsersProps) => {
  const { scrollRef, customScrollbar } = useCustomScrollbar<HTMLDivElement>(true);
  if (!('invalid_clients' in uploadedData)) {
    return <p>Нет данных о нераспознанных пользователях</p>;
  }
  if (!uploadedData.invalid_clients?.length) {
    return <p>Нет данных о нераспознанных пользователях</p>;
  }

  const rows: Array<{ name: string; row: string; reason: string }> = [];
  for (const item of uploadedData.invalid_clients) {
    if (!item.errors?.length) continue;
    for (const err of item.errors) {
      rows.push({
        name: concatArray([err.first_name, err.last_name], ' ') || '—',
        row: String(err.excel_row),
        reason: err.error,
      });
    }
  }
  if (!rows.length) {
    return <p>Нет данных о нераспознанных пользователях</p>;
  }

  return (
    <div {...stylex.props(styles.userTable, styles.userTableText)}>
      <div {...stylex.props(styles.userHeaderThree)}>
        <p {...stylex.props(styles.itemEmail)}>ФИО</p>
        <p {...stylex.props(styles.itemEmail)}>Строка</p>
        <p {...stylex.props(styles.itemEmail)}>Причина</p>
      </div>

      <div {...stylex.props(scrollbarStyles.host)}>
        <div ref={scrollRef} {...stylex.props(scrollbarStyles.scroll)}>
          <div {...stylex.props(styles.userGuestRowsThree)}>
            {rows.map((row, i) => (
              <div key={i} {...stylex.props(styles.userGuestRow)}>
                <p {...stylex.props(styles.userGuestItem)}>{row.name}</p>
                <p {...stylex.props(styles.userGuestItem)}>{row.row}</p>
                <p {...stylex.props(styles.userGuestItem)}>{row.reason}</p>
              </div>
            ))}
          </div>
        </div>
        {customScrollbar.visible && (
          <div {...stylex.props(scrollbarStyles.track)}>
            <div
              {...stylex.props(scrollbarStyles.thumb)}
              style={{
                height: `${customScrollbar.thumbHeight}px`,
                transform: `translateY(${customScrollbar.thumbTop}px)`,
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
